import React, { useMemo } from 'react';
import { Button } from '@mui/material';
import productCDN from '@surfline/quiver-assets';

import type { Taxonomy } from 'types/locationView';

const MAP_BACKGROUND = `${productCDN}/backgrounds/one-world-map.png`;

const TravelPageMap: React.FC<{ taxonomy: Taxonomy }> = ({ taxonomy }) => {
  const { name, associated } = taxonomy;
  const links = useMemo(
    () =>
      associated?.links?.map((link) => {
        if (link.key === 'www') {
          return (
            <a href={link.href} className="sl-button-link" key={link.key}>
              <h3>{name} Beaches Surf Reports and Forecasts</h3>
              <Button className="sl-travel-map__button" variant="primary">
                Launch Map View
              </Button>
            </a>
          );
        }
        return null;
      }) ?? null,
    [associated.links, name],
  );

  return (
    <div className="sl-travel-map" style={{ backgroundImage: `url(${MAP_BACKGROUND})` }}>
      <div className="sl-travel-map__overlay">{links}</div>
    </div>
  );
};

export default TravelPageMap;
